import {
  EngagementStatus,
  IEngagement,
  PayerPayeeEngagementStatus
} from "@wingspanhq/payments/dist/interfaces";
import { WSActionsMenuItem } from "@wingspanhq/fe-component-library/dist/lib/components/WSActions/WSActions";
import { useArchiveEngagementTypeModal } from "../modals/useArchiveEngagementTypeModal";
import { useArchiveNotAllowedModal } from "../modals/useArchiveNotAllowedModal";
import { useDeleteEngagementTypeModal } from "../modals/useDeleteEngagementTypeModal";
import { useDeleteNotAllowedModal } from "../modals/useDeleteNotAllowedModal";
import { useRestoreEngagementTypeModal } from "../modals/useRestoreEngagementTypeModal";
import { getAllPayeeEngagements } from "../../../services/payeeEngagement/getAllPayeeEngagements";
import { useXWingspanPayerId } from "../../Payees/routes/RoutePayeeDetails/useXWingspanPayerId";

type Props = {
  engagement: IEngagement;
  onDelete?: (engagement: IEngagement) => void;
};

export const useEngagementTypeDefaultActions = () => {
  const archiveEngagementTypeModal = useArchiveEngagementTypeModal();
  const archiveNotAllowedModal = useArchiveNotAllowedModal();
  const deleteEngagementTypeModal = useDeleteEngagementTypeModal();
  const deleteNotAllowedModal = useDeleteNotAllowedModal();
  const restoreEngagementTypeModal = useRestoreEngagementTypeModal();
  const xWingspanPayerId = useXWingspanPayerId();

  return async (props: Props) => {
    const actions: WSActionsMenuItem[] = [];

    const activeConnectedEngagementsResponse = await getAllPayeeEngagements(
      xWingspanPayerId,
      {
        filter: {
          status: { "!=": PayerPayeeEngagementStatus.Inactive },
          engagementId: props.engagement.engagementId
        },
        page: {
          size: 1
        }
      }
    );

    const allConnectedEngagementsResponse = await getAllPayeeEngagements(
      xWingspanPayerId,
      {
        filter: {
          engagementId: props.engagement.engagementId
        },
        page: {
          size: 1
        }
      }
    );

    const hasConnectedEngagements =
      allConnectedEngagementsResponse.data.length > 0;
    const hasConnectedActiveEngagements =
      activeConnectedEngagementsResponse.data.length > 0;

    if (props.engagement.status === EngagementStatus.Active) {
      if (hasConnectedActiveEngagements) {
        actions.push({
          disabled: true,
          onDisabledClick: async () => {
            archiveNotAllowedModal.open({
              engagement: props.engagement
            });
          },
          label: "Archive",
          icon: "archive"
        });
      } else {
        actions.push({
          onClick: async () => {
            archiveEngagementTypeModal.open({
              engagement: props.engagement
            });
          },
          label: "Archive",
          icon: "archive"
        });
      }
    } else {
      actions.push({
        onClick: async () => {
          restoreEngagementTypeModal.open({
            engagement: props.engagement
          });
        },
        label: "Restore",
        icon: "redo"
      });
    }

    if (hasConnectedEngagements) {
      actions.push({
        disabled: true,
        onDisabledClick: async () => {
          deleteNotAllowedModal.open({
            engagement: props.engagement
          });
        },
        label: "Delete",
        icon: "trash"
      });
    } else {
      actions.push({
        onClick: async () => {
          deleteEngagementTypeModal.open({
            engagement: props.engagement,
            onSuccess: props.onDelete || (() => {})
          });
        },
        label: "Delete",
        icon: "trash",
        destructive: true
      });
    }

    return actions;
  };
};
